export const range = (begin: number, end: number, interval = 1): number[] => {
  const result: number[] = [];
  for (let i = begin; i < end; i += interval) {
    result.push(i);
  }
  return result;
};

export default range;
